<template>
  <div class="activity_logs">
    <div class="d-flex justify-space-between mb-4">
      <div>
        <div class="page-title mb-2">บันทึกกิจกรรมผู้ใช้งาน</div>
      </div>

      <div class="d-flex flex-column gap-12">
        <div class="d-flex gap-12">
          <div style="max-width: 250px">
            <TextField
              hide-details
              placeholder="ค้นหา"
              append-icon="ic:baseline-search"
              @onChange="keyword = $event"
              @onEnter="getLogActivities()"
            ></TextField>
          </div>
        </div>
      </div>
    </div>

    <!-- Table -->
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th width="5%" class="text-center">ลำดับ</th>
            <th width="20%" class="text-left">กิจกรรม</th>
            <th width="20%" class="text-left">ฟังก์ชั่น</th>
            <th width="15%" class="text-left">รายละเอียด</th>
            <th width="15%" class="text-left">ผู้ใช้งาน</th>
            <th width="10%" class="text-left">สิทธิ์</th>
            <th width="15%" class="text-center">วันที่เเละเวลา</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, i) in logs" :key="i">
            <td class="text-center">
              {{ no(i + 1) }}
            </td>
            <td>
              <div class="ellipsis-1-line">
                <tooltip-text :text="item?.name" />
              </div>
            </td>
            <td>
              <tooltip-text :text="item?.function_name" />
            </td>
            <td>
              <div class="ellipsis-1-line">
                <tooltip-text :text="item?.description" />
              </div>
            </td>
            <td>
              <div class="ellipsis-1-line">
                <tooltip-text :text="item?.created_by" />
              </div>
            </td>
            <td>{{ item.user_type }}</td>
            <td class="text-center">
              {{ item.created_at | moment("DD/MM/YYYY H:m น.") }}
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <!-- Paginate -->
    <v-layout mt-4 justify-end class="custom_paginate" v-if="logs.length > 0">
      <v-flex shrink>
        <v-pagination
          v-model="paginate.current_page"
          :length="paginate.last_page"
          color="#DE7033"
          :total-visible="7"
          @input="getLogActivities"
        ></v-pagination>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { Icon } from "@iconify/vue2";
import TextField from "../../../components/input/TextField.vue";
import moment from "moment";

import { toDateTimeFormat } from "@/plugins/global-funcs";
export default {
  components: { TextField, Icon },
  name: "LogActivity",
  data() {
    return {
      toDateTimeFormat,
      keyword: "",
      logs: [],
      paginate: {
        current_page: 1,
        last_page: 1,
      },
    };
  },
  created() {
    this.getLogActivities();
  },
  methods: {
    async getLogActivities(page) {
      const payload = {
        page: page || 1,
        keyword: this.keyword,
      };
      let res = await this.$apiFire("Auth/getLogActivities", payload);
      if (res) {
        this.logs = res.data;
        this.paginate = {
          current_page: res.current_page,
          last_page: res.last_page,
        };
      }
    },
    no(index) {
      return (this.paginate.current_page - 1) * 10 + index;
    },
  },
};
</script>

<style lang="scss">
.activity_logs {
  .ellipsis-1-line {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }
  .btn_gradient {
    background: linear-gradient(90deg, #f15a29 0%, #fbb040 100%) !important;
    box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.25) !important;
    color: #fff !important;
  }

  // adjustment table
  .theme--light.v-data-table {
    box-shadow: 1px 1px 30px rgba(0, 0, 0, 0.1) !important;
    border-radius: 20px !important;
    .v-data-table__wrapper {
      table {
        thead {
          tr th {
            color: #b1b1b1;
            font-weight: 400;
            font-size: 14px;
          }
          tr:last-child {
            th {
              border-bottom: 1px solid #f15a29 !important;
            }
          }
        }
        tbody {
          tr td {
            font-size: 14px;
            color: #464647;
            font-weight: 400;
          }
          tr:hover {
            background-color: unset !important;
          }
          tr:not(:last-child) {
            td:not(.v-data-table__mobile-row),
            th:not(.v-data-table__mobile-row) {
              border-bottom: 0px solid rgba(0, 0, 0, 0.12) !important;
            }
          }
        }
      }
    }
  }

  // custom paginate
  .custom_paginate {
    .v-pagination__item {
      border-radius: 10px;
      box-shadow: unset !important;
    }
    .v-pagination__navigation {
      border-radius: 10px;
      box-shadow: unset !important;
      background-color: transparent !important;
    }
  }
}
</style>
